export const OPTIONS_MIN_LENGTH = 2;
export const OPTIONS_MAX_LENGTH = 12;
